import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    user: null,
    isLoggedIn: false,
};
export var userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        setUser: function (state, action) {
            state.user = action.payload;
            state.isLoggedIn = !!action.payload;
        },
    },
});
export var setUser = userSlice.actions.setUser;
export default userSlice.reducer;
